import NudgeBanner from './NudgeBanner.component';

export default NudgeBanner;
